import Image from 'next/image'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useSwiperRef } from '@/shared/lib/hooks/useSwiperRef'

import { SwiperArrows } from '../swiper-arrows/swiper-arrows'

import cl from './style.module.scss'

export const SpecialistsOur = () => {
	const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>()
	const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>()
	const items = [
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-1.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-2.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-3.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-4.jpg',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-5.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-6.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-7.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-8.png',
		'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-9.png'
	]
	return (
		<section className={cl.specialists}>
			<div className={cl.wrapper}>
				<h2 className={cl.title}>Люди, которые делают сервис</h2>
				<ul className={cl.list}>
					<li className={cl.item}>
						<b>Каждый сотрудник iPort&nbsp;&mdash; технический гик и&nbsp;фанат Apple.</b> <br /> Многие начинали
						работать ещё в&nbsp;период официальной поддержки Apple, что даёт им&nbsp;солидный бэкграунд и&nbsp;глубокие
						знания о&nbsp;работе с&nbsp;её&nbsp;устройствами. Мы&nbsp;&mdash;&nbsp;это&nbsp;про&nbsp;
						<b>структурный подход и&nbsp;любовь к&nbsp;технике.</b>
					</li>
					<li className={cl.item}>
						<b>Есть специалисты с&nbsp;разным фокусом работ</b>: кто‑то занимается сложными вещами вроде микросхем,
						другие&nbsp;&mdash; профессионалы модульного ремонта, делая его качественно и&nbsp;в&nbsp;кратчайшие сроки.
						Есть&nbsp;и&nbsp;наши &laquo;сенсеи&raquo;&nbsp;&mdash; те, кто{' '}
						<b>первыми разбираются с&nbsp;ремонтом новейших моделей</b> и&nbsp;разрабатывают курсы обучения для всей
						команды.
					</li>
				</ul>
			</div>
			<div className={cl.photos}>
				<div className={cl.column}>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-1.png'}
						alt={''}
						width={372}
						height={298}
					/>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-6.png'}
						alt={''}
						width={372}
						height={245}
					/>
				</div>
				<div className={cl.column}>
					<div className={cl.flex}>
						<Image
							src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-2.png'}
							alt={''}
							width={329}
							height={213}
						/>
						<Image
							src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-3.png'}
							alt={''}
							width={288}
							height={213}
							quality={100}
						/>
					</div>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-7.png'}
						alt={''}
						width={631}
						height={330}
					/>
				</div>
				<div className={cl.column}>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-4.jpg'}
						alt={''}
						width={445}
						height={298}
					/>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-8.png'}
						alt={''}
						width={445}
						height={245}
					/>
				</div>
				<div className={cl.column}>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-5.png'}
						alt={''}
						width={372}
						height={298}
					/>
					<Image
						src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/specialists-9.png'}
						alt={''}
						width={372}
						height={245}
					/>
				</div>
			</div>
			<Swiper
				modules={[Navigation]}
				className={cl.swiper}
				slidesPerView={'auto'}
				spaceBetween={20}
				navigation={{
					nextEl,
					prevEl
				}}>
				{items.map((item, index) => (
					<SwiperSlide className={cl.slide} key={index}>
						<Image src={item} alt={''} width={310} height={240} quality={100} />
					</SwiperSlide>
				))}
			</Swiper>
			<SwiperArrows nextElRef={nextElRef} prevElRef={prevElRef} className={cl.arrows} />
		</section>
	)
}
